import { toast } from 'sonner';

export type ToastVariant = 'success' | 'error' | 'info' | 'warning';

type ShowToastOptions = {
  description?: string;
  duration?: number;
};

export function showToast(
  message: string,
  variant: ToastVariant = 'success',
  options?: ShowToastOptions,
) {
  const toastOptions = {
    ...(options?.description ? { description: options.description } : {}),
    duration: options?.duration ?? 5000,
    closeButton: true,
  };

  switch (variant) {
    case 'success':
      return toast.success(message, toastOptions);
    case 'error':
      return toast.error(message, toastOptions);
    case 'warning':
      return toast.warning(message, toastOptions);
    case 'info':
      return toast.info(message, toastOptions);
  }
}

export { toast };
